<div fxFlex="100" fxLayout="column" fxLayoutAlign="center center">
  <img src="/assets/icons/not_found.svg" class="not-found__img" />
  <div class="not-found__text">Nothing here ...</div>
</div>
